<template>
  <div class="tiltPhotography">
    <div class="content">
      <ul class="ul">
        <li class="li" v-for="(item, index) in imgList" :key="index">
          <div class="img">
            <img :src="item.img" alt="" />
            <div class="layer">
              {{ item.desc }}
            </div>
          </div>
          <!-- <div class="name">
            {{ item.name }}
          </div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tiltPhotography',
  data() {
    return {
      imgList: [
        {
          img: require('./img/tilt_1.jpg'),
          name: '倾斜摄影',
          desc: '从多个角度观察地物，更加真实的反映地物的实际情况，而且相较于三维GIS技术应用庞大的三维数据倾斜摄影数据量小，易于网络发布，同时能够有效的降低城市三维建模成本。'
        },
        {
          img: require('./img/tilt_2.jpg'),
          name: '倾斜摄影',
          desc: '从多个角度观察地物，更加真实的反映地物的实际情况，而且相较于三维GIS技术应用庞大的三维数据倾斜摄影数据量小，易于网络发布，同时能够有效的降低城市三维建模成本。'
        },
        {
          img: require('./img/tilt_3.jpg'),
          name: '倾斜摄影',
          desc: '从多个角度观察地物，更加真实的反映地物的实际情况，而且相较于三维GIS技术应用庞大的三维数据倾斜摄影数据量小，易于网络发布，同时能够有效的降低城市三维建模成本。'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.tiltPhotography {
  .content {
    width: 100%;
    min-height: 450px;
    background: #ffffff;
    // border: 1px solid #979797;
    margin: 0 auto;
    .ul {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      min-height: 850px;
      padding: 45px 240px 0 240px;
      justify-content: space-between;
      .li {
        margin-top: 45px;
        text-align: center;
        .img {
          width: 416px;
          height: 234px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .layer {
            position: absolute;
            left: 0;
            bottom: -165px;
            width: 100%;
            height: 165px;
            transition: 0.5s;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-family: 'PingFang';
            font-size: 22px;
            line-height: 30px;
            box-sizing: border-box;
            padding: 23px 58px 0 39px;
            text-align: left;
          }
        }
        .name {
          margin-top: 18px;
          font-size: 26px;
          font-family: 'PingFang';
          font-weight: bold;
          color: #000000;
        }
        // &:hover {
        //   .img {
        //     .layer {
        //       bottom: 0;
        //     }
        //   }
        // }
      }
    }
  }
}
</style>
